// extracted by mini-css-extract-plugin
export default {"containerGlobal":"ControllerClients_containerGlobal__7J58j","containerData":"ControllerClients_containerData__PsmLI"};